export default __webpack_public_path__ + "static/media/triobanner.fed93994.png";